import React from 'react';
import classes from "./SliderSection.module.css";
import { Col, Container, Row } from 'react-bootstrap';
import SectionHeader from "../../components/SectionHeader";
import { SliderData } from '../../data/app-data';
import SliderBox from '../../components/SliderBox';
import CarouselSlider from '../../components/Carousel';

export default function SliderSection() {
    return (
        <Container>
            <Row className='py-5'>
                <Col md={6}>
                    <SectionHeader title={"Why Choose Us"} heading={`Trustworthy advice, proven solutions.`} className={classes.headerClass} />
                </Col>
                <Col md={12} className={`${classes.sliderDiv} my-5`}>
                    <CarouselSlider>
                        {SliderData?.map((e, i) => {
                            return (
                                <SliderBox data={e} key={i} />
                            )
                        })}
                    </CarouselSlider>
                </Col>
            </Row>
        </Container>
    )
}
